// ./components/ModifyPaymentModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Select, Flex, Typography, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const { Title } = Typography;

const ModifyPaymentModal = ({
  visible,
  onClose,
  currentRecord,
  onSuccess,
  getTableListFn,
  pagination,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isPay, setIsPay] = useState(false); // 默认 false = Allow To Pay

  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  // 当 Modal 打开时，设置初始值
  useEffect(() => {
    if (visible && currentRecord) {
      form.setFieldsValue({
        isPay: false,
        payAmount: currentRecord.payAmount || undefined,
        payRemark: currentRecord.payRemark || undefined,
      });
      setIsPay(false);
    }
  }, [visible, currentRecord, form]);

  // 监听 isPay 变化
  const handleIsPayChange = (value) => {
    setIsPay(value);
    // 当切换时，触发 payAmount 的重新校验
    setTimeout(() => {
      form.validateFields(['payAmount']).catch(() => {});
    }, 0);
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await http.post(api.getUpdatePayAmount, {
        id: currentRecord.id,
        payAmount: values.payAmount, 
        payRemark: values.payRemark,
        isPay: values.isPay, 
      });

      if (response.code === "1") {
        message.success("Payment amount modified successfully.");
        onClose();
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Failed to modify payment amount");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setIsPay(false);
    onClose();
  };

  // 自定义校验规则 - 动态 required
  const validatePayAmount = (rule, value) => {
    // 当 isPay 为 false（Allow To Pay）时，payAmount 必填
    if (isPay === false && !value) {
      return Promise.reject("Please input payment amount");
    }
    return Promise.resolve();
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Title level={4} className="mg">
            Modify Payment Amount
          </Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={handleCancel}
      maskClosable={false} 
      footer={[
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', width: '100%' }}>
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      ]}
    >
      <div className="model_top" style={{ width: "100%" }}>
        <div className="model_content" style={{ marginTop: 20 }}>
          <Form
            {...layout}
            onFinish={onFinish}
            form={form}
            initialValues={{
              isPay: false,
            }}
            labelCol={{
              style: {
                width: "150px",
              },
            }}
            wrapperCol={{
              style: {
                flex: 1,
              },
            }}
          >
      
            <Form.Item
              name="payAmount"
              label="Payment Amount"
              required={!isPay} 
              rules={[
                { validator: validatePayAmount },
              ]}
              validateTrigger="onChange"
            >
              <Input type="number" placeholder="Enter payment amount" />
            </Form.Item>

            <Form.Item name="payRemark" label="Payment Remark">
              <Input.TextArea placeholder="Enter payment remark (optional)" />
            </Form.Item>
                  <Form.Item
              name="isPay"
              label="Pay?"
            >
              <Select
                options={[
                  { label: 'Do Not Pay', value: true },
                  { label: 'Allow To Pay', value: false },
                ]}
                onChange={handleIsPayChange}
              />
            </Form.Item>

          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default ModifyPaymentModal;